<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="shadow-btm">
          <div class="row">
            <div
              class="col-lg-12 col-sm-12 my-auto d-flex align-items-center mb-4">
              <a
                class="pr-2 text-dark cursor-pointer"
                v-on:click="$router.push('/member-list')"
                ><span class="font-24 mr-2"
                  ><img src="/images/back-arrow.svg" width="18"
                /></span>
              </a>
              <h4 class="mb-0 lg-bld">User Activity</h4>
            </div>
          </div>
        </div>
        <div class="page-content">
          <div class="col-lg-12 col-sm-12 mx-auto">
            <div class="card p-4">
              <div>
                <div class="col-lg-12 col-sm-9">
                  <div class="row">
                    <div class="col-lg-6 col-sm-6 form-group">
                      <label class="font18">Name</label>
                      <div class="font20">
                        {{ detail.first_name }} {{ detail.middle_name }}
                        {{ detail.last_name }}
                      </div>
                    </div>
                    <div class="col-lg-6 col-sm-6 form-group">
                      <label class="font18">Mobile Number</label>
                      <div class="font20">{{ detail.mobile }}</div>
                    </div>
                    <div class="col-lg-6 col-sm-6 form-group">
                      <label class="font18">Email</label>
                      <div class="font20">{{ detail.email }}</div>
                    </div>

                    <div class="col-lg-6 col-sm-6 form-group">
                      <label class="font18">Membership</label>
                      <div class="font20">{{ detail.membership_plan }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 text-center mt-3 mb-3">
                <p class="font-18 font-medium">
                  <span class="text-brand"
                    >{{
                      detail.profile_percentage
                        ? detail.profile_percentage
                        : "0"
                    }}%</span
                  >
                  Profile Completed
                </p>
                <div class="progress" style="height: 6px">
                  <div
                    class="progress-bar bg-brand"
                    role="progressbar"
                    :style="'width: ' + detail.profile_percentage + '%'"
                    aria-valuenow="25"
                    aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>
              <div class="col-12 row mt-2 mb-3">
                <div class="col-5 shadow-btm2" style="margin-right: 25px">
                  <div class="row">
                    <div
                      class="col-6"
                      style="text-align: start; font-weight: bold">
                      Last Login
                    </div>
                    <div
                      class="col-6"
                      style="text-align: end; font-weight: bold">
                      {{
                        detail.last_login
                          ? $helperService.getFormatedDateAndTime(
                              detail.last_login
                            )
                          : ""
                      }}
                    </div>
                    <div
                      class="col-6"
                      style="text-align: start; font-weight: bold">
                      IP address
                    </div>
                    <div
                      class="col-6"
                      style="text-align: end; font-weight: bold">
                      {{ detail.ip_address }}
                    </div>
                  </div>
                </div>
                <div class="col-5 shadow-btm2">
                  <div class="row">
                    <div
                      class="col-6"
                      style="text-align: start; font-weight: bold">
                      Interest Sent
                    </div>
                    <div
                      class="col-6"
                      style="text-align: end; font-weight: bold"></div>
                    <div class="col-4" style="font-weight: bold">
                      Accepted - {{ detail.acceptedSentIntrestCount }},
                    </div>
                    <div class="col-4" style="font-weight: bold">
                      Rejected - {{ detail.rejectedSentIntrestCount }},
                    </div>
                    <div class="col-4" style="font-weight: bold">
                      Pending - {{ detail.pendingSentIntrestCount }},
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 row mt-2 mb-3">
                <div class="col-5 shadow-btm2" style="margin-right: 25px">
                  <div class="row">
                    <div
                      class="col-6"
                      style="text-align: start; font-weight: bold">
                      Shortlisted
                    </div>
                    <div
                      class="col-6"
                      style="text-align: end; font-weight: bold">
                      {{ detail.shortListedProfileCount }}
                    </div>
                    <div class="col-6" style="text-align: start"></div>
                  </div>
                </div>
                <div class="col-5 shadow-btm2">
                  <div class="row">
                    <div
                      class="col-6"
                      style="text-align: start; font-weight: bold">
                      Interest Received
                    </div>
                    <div class="col-6" style="text-align: end"></div>
                    <div class="col-4" style="font-weight: bold">
                      Accepted - {{ detail.acceptedReceivedIntrestCount }},
                    </div>
                    <div class="col-4" style="font-weight: bold">
                      Rejected - {{ detail.rejectedReceivedIntrestCount }},
                    </div>
                    <div class="col-4" style="font-weight: bold">
                      Pending - {{ detail.pendingReceivedIntrestCount }},
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 row mt-2 mb-3">
                <div class="col-5 shadow-btm2" style="margin-right: 25px">
                  <div class="row">
                    <div
                      class="col-6"
                      style="text-align: start; font-weight: bold">
                      Profile Visitors
                    </div>
                    <div
                      class="col-6"
                      style="text-align: end; font-weight: bold">
                      {{ detail.profileViewCount }}
                    </div>
                    <div
                      class="col-6"
                      style="text-align: start; font-weight: bold">
                      Blocked
                    </div>
                    <div
                      class="col-6"
                      style="text-align: end; font-weight: bold">
                      {{ detail.bloockCount }}
                    </div>
                  </div>
                </div>
                <div class="col-5 shadow-btm2">
                  <div class="row">
                    <div
                      class="col-6"
                      style="text-align: start; font-weight: bold">
                      Contacts I Viewed
                    </div>
                    <div
                      class="col-6"
                      style="text-align: end; font-weight: bold">
                      {{ detail.ContactsViewed }}
                    </div>
                    <div
                      class="col-6"
                      style="text-align: start; font-weight: bold">
                      Viewed My Contacts
                    </div>
                    <div
                      class="col-6"
                      style="text-align: end; font-weight: bold">
                      {{ detail.myContactsViewd }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 row mt-2 mb-3">
                <div class="col-5 shadow-btm2" style="margin-right: 25px">
                    <div
                    class="col-12"
                    style="text-align: start; font-weight: bold">
                    HANDPICK SUGGESTIONS FROM NIMBALKAR :
                  </div>
                  <div
                    class="col-12"
                    style="text-align: start; font-weight: bold">
                    <p v-for="(data, index) in one_way" :key="index">Sent Date: {{ data.date ? $helperService.getNewFormatedDate(data.date) : "" }} = {{data.total}} One Way</p>
                    <p v-for="(data, index) in two_way" :key="index">Sent Date: {{ data.date ? $helperService.getNewFormatedDate(data.date) : "" }} = {{data.total}} Two Way</p>
                    <p v-for="(data, index) in vice_versa" :key="index">Sent Date: {{ data.date ? $helperService.getNewFormatedDate(data.date) : "" }} = {{data.total}} Vice-Versa</p>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 col-sm-12 text-center mt-2">
                <button
                  type="button"
                  class="fil-btn px-4 ml-3"
                  v-on:click="$router.go(-1)"
                  id="cancel-button">
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "UserActivity",
  components: {},
  data() {
    return {
      uuid: this.$route.params.uuid,
      detail: {},
      one_way : [],
      two_way : [],
      vice_versa : []
    };
  },
  mounted() {
    this.$helperService.showMenu("true");
    if (this.uuid) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      var obj = {};
      obj.uuid = this.uuid;
      this.$api
        .getAPI({
          _action: "/user-activity",
          _body: obj,
        })
        .then((res) => {
          console.log("res", res);
          this.detail = res.data;
          this.one_way = res.oneway;
          this.two_way = res.twoway;
          this.vice_versa = res.vice_versa;
        })
        .catch(() => {});
    },
  },
};
</script>
